(ns storage.core
  (:refer-clojure :exclude [set get remove])
  (:import
   [goog.storage Storage]
   [goog.storage.mechanism HTML5LocalStorage]))

(defn get [key]
  (let [store (Storage. (HTML5LocalStorage.))]
    (.get store key)))

(defn set [key value]
  (let [store (Storage. (HTML5LocalStorage.))]
    (.set store key value)))

(defn remove [key]
  (let [store (Storage. (HTML5LocalStorage.))]
    (.remove store key)))

